function sizeFits() {
  let size_array = [];
  size_array["AA"] = "For bra sizes: 0B, 1A, 2AA";
  size_array["A"] = "For bra sizes: 0C, 1B, 2A, 3AA";
  size_array["B"] = "For bra sizes: 0D, 1C, 2B, 3A";
  size_array["C"] = "For bra sizes: 0DD, 1D, 2C, 3B";
  size_array["D"] = "For bra sizes: 0E, 1DD, 2D, 3C, 4B";
  size_array["E"] = "For bra sizes: 0F, 1E, 2DD, 3D, 4C, 5B";
  size_array["F"] = "For bra sizes: 1F, 2E, 3DD, 4D, 5C, 6B";
  size_array["G"] = "For bra sizes: 2F, 3E, 4DD, 5D, 6C";
  size_array["H"] = "For bra sizes: 2FF, 3F, 4E, 5DD, 6D";
  size_array["I"] = "For bra sizes: 2G, 3FF, 4F, 5E, 6DD";
  size_array["J"] = "For bra sizes: 2GG, 3G, 4FF, 5F, 6E, 7DD";
  size_array["K"] = "For bra sizes: 2H,3GG, 4G, 5FF, 6F, 7E";
  size_array["L"] = "For bra sizes: 2HH, 3H, 4GG, 5G, 6FF, 7F";
  size_array["M"] = "For bra sizes: 2J, 3HH, 4H, 5GG, 6G, 7FF";
  size_array["A/B"] = "For bra sizes: 0C, 1B, 2A, 3AA";
  size_array["C/D"] = "For bra sizes: 0DD, 1D, 2C, 3B";
  size_array["DD/E/F"] = "For bra sizes: 0F, 1E, 2DD, 3D, 4C, 5B";
  size_array["G/H"] = "For bra sizes: 2F, 3E, 4DD, 5D, 6C";
  size_array["I/J/K"] = "For bra sizes: 2G, 3FF, 4F, 5E, 6DD";
  

  let radioButtons = document.querySelectorAll('input[type="radio"].Misura');

  // Loop through each radio button and add an event listener
  radioButtons.forEach(button => {
      button.addEventListener('click', event => {
      let fitTxt = document.querySelector("#custom-size-fit");
      console.log(`Selected size: ${button.value}`);

      if(button.value == 'AA') {
        fitTxt.innerHTML =  size_array["AA"];
      }
      else if(button.value == 'A') {
        fitTxt.innerHTML =  size_array["A"];
      }
      else if(button.value == 'B') {
        fitTxt.innerHTML =  size_array["B"];
      }
      else if(button.value == 'C') {
        fitTxt.innerHTML =  size_array["C"];
      }
      else if(button.value == 'D') {
        fitTxt.innerHTML =  size_array["D"];
      }
      else if(button.value == 'E') {
        fitTxt.innerHTML =  size_array["E"];
      }
      else if(button.value == 'F') {
        fitTxt.innerHTML =  size_array["F"];
      }
      else if(button.value == 'G') {
        fitTxt.innerHTML =  size_array["G"];
      }
      else if(button.value == 'H') {
        fitTxt.innerHTML =  size_array["H"];
      }
      else if(button.value == 'I') {
        fitTxt.innerHTML =  size_array["I"];
      }
      else if(button.value == 'J') {
        fitTxt.innerHTML =  size_array["J"];
      }
      else if(button.value == 'K') {
        fitTxt.innerHTML =  size_array["K"];
      }
      else if(button.value == 'L') {
        fitTxt.innerHTML =  size_array["L"];
      }
      else if(button.value == 'M') {
        fitTxt.innerHTML =  size_array["M"];
      }
      else if(button.value == 'A/B') {
        fitTxt.innerHTML =  size_array["A/B"];
      }
      else if(button.value == 'C/D') {
        fitTxt.innerHTML =  size_array["C/D"];
      }
      else if(button.value == 'DD/E/F') {
        fitTxt.innerHTML =  size_array["DD/E/F"];
      }
      else if(button.value == 'G/H') {
        fitTxt.innerHTML =  size_array["G/H"];
      }
      else if(button.value == 'I/J/K') {
        fitTxt.innerHTML =  size_array["I/J/K"];
      }
      else{
        fitTxt.innerHTML = 'Selected size: Not found';
      }
    });
  });
}
sizeFits()